module.exports = __webpack_public_path__ + "img/various-icon-f.704fd296.png";